import { pluginFactory } from '../utils/plugins';
import { VBHoverPlugin } from './hover';
import { VBModalPlugin } from './modal';
import { VBPopoverPlugin } from './popover';
import { VBScrollspyPlugin } from './scrollspy';
import { VBTogglePlugin } from './toggle';
import { VBTooltipPlugin } from './tooltip';
import { VBVisiblePlugin } from './visible'; // Main plugin for installing all directive plugins

export var directivesPlugin = /*#__PURE__*/pluginFactory({
  plugins: {
    VBHoverPlugin: VBHoverPlugin,
    VBModalPlugin: VBModalPlugin,
    VBPopoverPlugin: VBPopoverPlugin,
    VBScrollspyPlugin: VBScrollspyPlugin,
    VBTogglePlugin: VBTogglePlugin,
    VBTooltipPlugin: VBTooltipPlugin,
    VBVisiblePlugin: VBVisiblePlugin
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/directives/index.js
// module id = 1048
// module chunks = 44